import { useEffect, useRef, useCallback } from "react";
import { Phone, CalendarClock } from "lucide-react";
import { Logo } from "./Logo";
import { BUSINESS } from "../lib/constants";

const LINKS = [
  { label: "Pricing", hash: "#pricing" },
  { label: "The Work", hash: "#work" },
  { label: "Process", hash: "#process" },
  { label: "Contact", hash: "#contact" },
];

export const scrollToHash = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export default function Navbar({ onBook }) {
  const ref = useRef(null);

  const handleNav = useCallback((e, hash) => {
    e.preventDefault();
    scrollToHash(hash);
  }, []);

  useEffect(() => {
    const onScroll = () => {
      if (!ref.current) return;
      ref.current.style.boxShadow =
        window.scrollY > 24
          ? "0 12px 40px -18px rgba(0,0,0,0.9)"
          : "none";
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      ref={ref}
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-50 bg-midnight/60 backdrop-blur-xl border-b border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between gap-4">
        <a
          href="#top"
          data-testid="nav-home-link"
          onClick={(e) => handleNav(e, "#top")}
          aria-label="Everything Works Services home"
        >
          <Logo />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.hash}
              href={l.hash}
              data-testid={`nav-link-${l.hash.slice(1)}`}
              onClick={(e) => handleNav(e, l.hash)}
              className="font-mono text-[11px] tracking-[0.25em] uppercase text-mist hover:text-white transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={BUSINESS.phoneHref}
            data-testid="nav-phone-link"
            className="hidden lg:flex items-center gap-2 font-mono text-xs text-mist hover:text-crystal transition-colors duration-200"
          >
            <Phone size={14} strokeWidth={1.8} />
            {BUSINESS.phone}
          </a>
          <button
            data-testid="nav-book-btn"
            onClick={() => onBook({})}
            className="group relative inline-flex items-center gap-2 rounded-full bg-crystal px-5 py-2.5 font-mono text-[11px] font-medium tracking-[0.2em] uppercase text-midnight transition-transform duration-200 hover:-translate-y-0.5"
          >
            <CalendarClock size={14} strokeWidth={2} />
            Book a time
          </button>
        </div>
      </div>
    </header>
  );
}
